import $ from 'jquery';
import { AJAX_URL } from './config';

// Catch when login form is submitted
$('#loginform').on('submit', function (e) {
  // Prevent default
  e.preventDefault();

  // Get form data
  const data = {
    username: $('#user_login').val(),
    password: $('#user_pass').val(),
    redirect_to: $('#redirect_to').val()
  };

  $.ajax({
    url: `${AJAX_URL}wl_post_login_form`,
    data: data,
    type: 'POST',
    dataType: 'json',
    encode: true,
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
  })
    .then(({ success, data }) => {
      if (!success) {
        $('#error-message .notice__message').html(data.error);
        $('#error-message').removeClass('u--display-none');
        return;
      } else {
        __ss_noform.push([
          'submit',
          null,
          '9236a425-ccf6-4c7e-8dda-ed539a6de7a5'
        ]);
        // Redirect to the page the user was on
        window.location.href = data.redirect;
      }
    })
    .catch((err) => console.log(err.message));
});
